import React, { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';

// 倒计时-时分秒（3小时 = 10800秒）
const COUNTDOWN_NUM = 7200;

export default function Countdown() {
  let createTime = dayjs().hour(13).minute(0).second(0).millisecond(0);
  const initCountdownTime = React.useMemo(() => {
    if (!createTime) return 0;

    const specificDate = dayjs(createTime);
    if (!specificDate.isValid()) return 0;

    const currentDate = dayjs();
    const differenceInMilliseconds = currentDate.diff(specificDate);
    const differenceInSeconds = Math.floor(differenceInMilliseconds / 1000);
    return COUNTDOWN_NUM - (differenceInSeconds % COUNTDOWN_NUM);
  }, [createTime]);

  const [countdownTime, setCountdownTime] = useState<number>(initCountdownTime);
  const countdownTimer = useRef<{ timer?: NodeJS.Timeout; time: number }>({
    time: initCountdownTime, // 初始化timer的time值
  });

  // 开始倒计时
  const startCountdownTimer = React.useCallback(() => {
    // 避免重复创建定时器（先清后创）
    if (countdownTimer.current.timer) {
      clearInterval(countdownTimer.current.timer);
    }

    // 重新计算当前剩余时间
    const specificDate = dayjs(createTime);
    const currentDate = dayjs();
    const differenceInSeconds = Math.floor(currentDate.diff(specificDate) / 1000);
    let remainTime = COUNTDOWN_NUM - (differenceInSeconds % COUNTDOWN_NUM);
    countdownTimer.current.time = remainTime;
    setCountdownTime(remainTime); // 立即更新，避免延迟

    // 启动定时器
    countdownTimer.current.timer = setInterval(() => {
      countdownTimer.current.time -= 1;
      const currentTime = countdownTimer.current.time;
      setCountdownTime(currentTime);

      // 倒计时结束后重置
      if (currentTime <= 0) {
        countdownTimer.current.time = COUNTDOWN_NUM;
        setCountdownTime(COUNTDOWN_NUM);
      }
    }, 1000);
  }, [createTime]); // eslint-disable-line

  // 依赖项精准化，避免无效执行
  useEffect(() => {
    startCountdownTimer();

    return () => {
      if (countdownTimer.current.timer) {
        clearInterval(countdownTimer.current.timer);
      }
    };
  }, [startCountdownTimer]); // eslint-disable-line

  // 将时长(秒)转化为时分秒的形式
  const getTime = React.useCallback((value: number) => {
    // 兼容负数/0的情况
    const secondTime = Math.max(parseInt(String(value)), 0);
    const hourTime = Math.floor(secondTime / 3600);
    const minuteTime = Math.floor((secondTime % 3600) / 60);
    const remainSecond = secondTime % 60;

    // 统一补0逻辑
    const padZero = (num: number) => num.toString().padStart(2, '0');

    return {
      hourTime: hourTime,
      minuteTime: padZero(minuteTime),
      secondTime: padZero(remainSecond),
    };
  }, []);

  const countdownData = getTime(countdownTime);
  return (
    <div className="countdown-container d-flex-r ai-center">
      <div className="mr-2 font-size-12 font-widget-600">限时优惠</div>
      <span>{countdownData.hourTime}</span>:<span>{countdownData.minuteTime}</span>:
      <span>{countdownData.secondTime}</span>
    </div>
  );
}
